import { z } from 'zod';
import { zPrintView, zPrintInstructions, zPrintOrientation, zPrintWorkoutLayout, zPrintLettering, zPrintHeaderSize, zPrintEachSidePlacement, } from '../../core';
export var BlockDraftAsyncDomain;
(function (BlockDraftAsyncDomain) {
    BlockDraftAsyncDomain.Module = 'BlockDraftAsync';
    const module = z.literal(BlockDraftAsyncDomain.Module);
    BlockDraftAsyncDomain.Publish = z.object({
        module,
        type: z.literal('Publish'),
        input: z.object({
            blockId: z.uuid(),
        }),
    });
    const zPrintOptions = z.object({
        layout: zPrintWorkoutLayout,
        orientation: zPrintOrientation,
        view: zPrintView,
        instructions: zPrintInstructions,
        exerciseId: z.string().nullable(),
        metricIds: z.array(z.string()),
        sets: z.array(z.number()).nullable(),
        brandColor: z.string().nullable(),
        locale: z.string().nullable(),
        lettering: zPrintLettering,
        fitToPage: z.boolean(),
        printBaseBlock: z.boolean(),
        headerText: z.string().nullable(),
        headerSize: zPrintHeaderSize,
        eachSidePlacement: zPrintEachSidePlacement,
    });
    BlockDraftAsyncDomain.Print = z.object({
        module,
        type: z.literal('Print'),
        input: z.object({
            printTaskId: z.uuid(),
            blockId: z.uuid(),
            profileIds: z.array(z.uuid()),
            workoutIds: z.array(z.uuid()),
            printOptions: zPrintOptions,
        }),
    });
    BlockDraftAsyncDomain.DeletePrintTask = z.object({
        module,
        type: z.literal('DeletePrintTask'),
        input: z.object({
            printTaskId: z.uuid(),
            blockId: z.uuid(),
        }),
    });
})(BlockDraftAsyncDomain || (BlockDraftAsyncDomain = {}));
//# sourceMappingURL=async.js.map